import { getStates } from '@/api/states';
import { useQuery } from '@tanstack/react-query';

const stateKeys = {
	allStates: () => ['all_states'] as const,
};

export const useStates = () =>
	useQuery({
		queryKey: stateKeys.allStates(),
		queryFn: () => getStates(),
		refetchOnWindowFocus: false,
		keepPreviousData: true,
	});
